/* ==========================================================================
   SelectPanel > Template
   ========================================================================== */
/* Import modules */
const { html } = require('common-tags');

const { sanitizeObject } = require('@bluekiri/alexandria-contrib-components/helpers/sanitize');
const { prepareDataConfig, addData } = require('@bluekiri/alexandria/helpers/dataHelpers');
const InputTemplate = require('@bluekiri/alexandria-contrib-components/components/input-rxjs/template');

const { getUpdatedChoices, getChoiceByDeafult, getChoiceValue } = require('./helpers');

const { PLACEMENT, APPENDTOPARENT, AUTOWIDTH, ICON } = require('./constants');
const configuration = require('./client/js/config');

const renderInput = (data, context) => {
    const { title, label, icon = ICON, items = [], value } = data;

    const { label: inputValue } = getChoiceByDeafult({ items, value }) || {};

    const dataInput = addData(
        {
            config: { isAlternative: false },
            type: 'button',
            title,
            label,
            icon,
            value: inputValue,
            disabled: false,
            hasLoader: true
        },
        { type: configuration().type.input }
    );

    return InputTemplate(dataInput, context);
};

/**
 * SelectPanel template
 * @param {object} data Object containing the data model for this component.
 * @param {object} context The general context object.
 * @returns {object} Additional data to have available in the template
 */
module.exports = function Template(data, context) {
    /* Data */
    const {
        config = {},
        placement = PLACEMENT,
        appendToParent = APPENDTOPARENT,
        autoWidth = AUTOWIDTH,
        items = [{ label: ' ' }]
    } = data;

    const { styles = [] } = config;
    const { dataType } = prepareDataConfig(config.data);

    const value = getChoiceValue(data);

    /* Prepare config */
    const configData = sanitizeObject({
        ...config,
        dataType,
        context,
        placement,
        appendToParent,
        autoWidth,
        hasGroups: items.some(item => item.choices),
        value,
        items: getUpdatedChoices({ items, value })
    });

    const dataConfigAttr = html(`data-config='${JSON.stringify({ ...configData })}'`);
    const dataTypeAttr = dataType ? html(`data-type="${dataType}"`) : html('');

    /* -Template */
    return html(`
        <div class='${['select-panel', ...styles].join(' ').trim('')}'
            data-component='${configuration().component}'
            ${dataTypeAttr}
            ${dataConfigAttr}>
            ${renderInput(data, context)}
        </div>
    `);
};
